const INITIAL_STATE = {
  pageState: 'policy',
};

const mock = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_MOCK_PAGE_STATE':
      return Object.assign({}, state, {
        pageState: action.state,
      });
    default:
      return state;
  }
};

export default mock;
